import React, { Component } from 'react';
import Resolution from 'engine/Resolution.js';
import Dropdown from 'react-dropdown'
import {RESOLUTION_DROPDOWN} from 'constants/contextual-help.js';
import { connect } from "react-redux";
import {
    setContextualHelp,
    setDisplayResolution
} from "actions/index.js";

function ResolutionDropdown(props) {
    function onSelectResolution(option) {
        props.sequencerEngine.resolution = option;
        props.setDisplayResolution(option);
        props.sequencerEngine.updateSteps();
        if (props.sequencerEngine.tracks.length > 0) {
            props.sequencerEngine.select(
                props.sequencerEngine.cursor.track,
                0);
        }
    }

    return (
        <div
          onMouseOver={() => props.setContextualHelp(RESOLUTION_DROPDOWN)}
          onMouseLeave={() => props.setContextualHelp(undefined)}
          >
        <Dropdown
          className='resolution-dropdown'
          options={resolutionOptions}
          onChange={(o) => onSelectResolution(o.value)}
          value={getResolutionOption(props.resolution)}
          placeholder="Select a resolution" />
        </div>
    );
}

const resolutionOptions = [
    {value: new Resolution(4, false), label:'1/4'},
    {value: new Resolution(4, true), label:'1/4t'},
    {value: new Resolution(8, false), label:'1/8'},
    {value: new Resolution(8, true), label:'1/8t'},
    {value: new Resolution(16, false), label:'1/16'},
    {value: new Resolution(16, true), label:'1/16t'},
    {value: new Resolution(32, false), label:'1/32'},
    {value: new Resolution(32, true), label:'1/32t'}
];

function getResolutionOption(value) {
    for (var i=0; i < resolutionOptions.length; i++) {
        if (resolutionOptions[i].value.resolution == value.resolution &&
           resolutionOptions[i].value.isTriplet == value.isTriplet) {
            return resolutionOptions[i];
        }
    }
    return null;
}



const mapStateToProps = state => {
    return {
        resolution: state.sequencer.displayResolution,
    };
}

const mapDispatchToProps = dispatch => {
    return {
        setContextualHelp: (element) => dispatch(setContextualHelp(element)),
        setDisplayResolution: (resolution) => dispatch(setDisplayResolution(resolution))
    };
};
 
export default connect(mapStateToProps, mapDispatchToProps)(ResolutionDropdown);
